<template>
  <div class="personalCenter">
    <!-- 店铺id -->
    <div style="font-size: 0.8rem; display: none" @click="clear">清除缓存</div>
    <!-- 顶部信息和订单 -->
    <div class="header">
      <!-- 背景 -->
      <img :src="imgPath + 'beijin.png'" alt class="bg" />
      <div class="storeId">店铺ID: {{ wxStoreId }}</div>
      <div class="info">
        <!-- 头像 -->
        <div v-if="isLogin" class="flex">
          <img :src="userInfo.member.portrait" @click="jumpUrl('/setUp')" alt />
          <div class="login">
            <div v-if="userInfo.member">
              {{
                userInfo.member.nick_name == ""
                  ? userInfo.member.user_name
                  : userInfo.member.nick_name
              }}
            </div>
            <div class="badge">会员</div>
          </div>
        </div>
        <!-- 未登录 -->
        <div v-else class="flex">
          <img @click="goLogin()" :src="imgPath + 'touxiang.png'" alt />
          <span class="go_login" @click="goLogin()">登录/注册</span>
        </div>
      </div>
      <!-- 订单 -->
      <div class="order">
        <div class="flex_b title" @click="jumpUrl('/order?type=0')">
          <span>我的订单</span>
          <div class="right">
            <span>全部订单</span>
            <qdd-icon class="iconyou" color="#999" size=".3rem"></qdd-icon>
          </div>
        </div>
        <ul class="flex_a order_option">
          <li @click="jumpUrl('/order?type=20')">
            <img :src="imgPath + 'daifiahu.png'" alt />
            <div
              class="yuan"
              v-if="
                userInfo.order && userInfo.order.dfh != 0 && userInfo.order.dfh
              "
            >
              {{ userInfo.order.dfh }}
            </div>
            <span>待发货</span>
          </li>
          <li @click="jumpUrl('/order?type=30')">
            <img :src="imgPath + 'daishouhuo.png'" alt />
            <div
              class="yuan"
              v-if="
                userInfo.order && userInfo.order.dsh != 0 && userInfo.order.dsh
              "
            >
              {{ userInfo.order.dsh }}
            </div>
            <span>待收货</span>
          </li>
          <li @click="jumpUrl('/order?type=100')">
            <img :src="imgPath + 'daiqueuc.png'" alt />
            <div
              class="yuan"
              v-if="
                userInfo.order && userInfo.order.dqr != 0 && userInfo.order.dqr
              "
            >
              {{ userInfo.order.dqr }}
            </div>
            <span>待确认</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="hb_banner" @click="jumpUrl('/shareList')">
      <img :src="ossImgPath + 'jfschaibao.png'" alt />
    </div>

    <!-- 积分 -->
    <div class="integral">
      <ul>
        <li>
          <div class="num">
            {{ userInfo.member ? userInfo.member.b_money || "0" : "0" }}
          </div>
          <div>可用积分</div>
        </li>
        <li>
          <div class="num">
            {{ userInfo.member ? userInfo.member.integral_used || "0" : "0" }}
          </div>
          <div>已用积分</div>
        </li>
        <li>
          <img
            :src="imgPath + 'jifenicon.png'"
            alt
            @click="
              jumpUrl('/record?b_money=' + (userInfo.member.b_money || 0))
            "
          />
          <div>我的积分</div>
        </li>
      </ul>
      <img :src="imgPath + 'jaintouu.png'" alt class="line" />
    </div>

    <!-- 选项列表 -->
    <div class="pd2">
      <ul class="list">
        <li
          class="flex_b"
          @click="jumpUrl('/record?b_money=' + (userInfo.member.b_money || 0))"
        >
          <div>
            <qdd-icon class="iconjifen" color="#FD3C3C" size=".5rem"></qdd-icon>
            <span>积分记录</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>

        <li class="flex_b" @click="jumpUrl('/collecExchange?state=2')">
          <div>
            <qdd-icon
              class="iconcollection"
              color="#FD3C3C"
              size=".5rem"
            ></qdd-icon>
            <span>我的收藏</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>

        <li class="flex_b" @click="jumpUrl('/addressList')">
          <div>
            <qdd-icon
              class="iconlocation"
              color="#FD3C3C"
              size=".5rem"
            ></qdd-icon>
            <span>收货地址</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>
        <!-- <a :href="'tel:' + storeInfo.phone_mob"> -->
        <li class="flex_b pr" @click="goPhoneStore">
          <div>
            <qdd-icon
              class="iconxiaoxi2"
              color="#FD3C3C"
              size=".5rem"
            ></qdd-icon>
            <span>联系商家</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
          <a
            v-if="this.storeInfo.is_custorm_count == 1"
            class="phone_tel_x"
            :href="'tel:' + storeInfo.phone_mob"
          ></a>
        </li>

        <li
          class="flex_b"
          @click="jumpUrl('/mobile?mobile=' + (userInfo.member.mobile || 0))"
        >
          <div>
            <qdd-icon
              class="iconshouji1"
              color="#FD3C3C"
              size=".5rem"
            ></qdd-icon>
            <span>手机号码</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>
        <!-- <li class="flex_b" @click="kefuServe">
          <div>
            <qdd-icon class="iconkefu" color="#FD3C3C" size=".5rem"></qdd-icon>
            <span>在线客服</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>-->
        <li class="flex_b" @click="jumpUrl('/settleAccountRecord')">
          <div>
            <qdd-icon
              class="iconjiekuanmingxi"
              color="#FD3C3C"
              size=".5rem"
            ></qdd-icon>
            <span>结账记录</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>
        <li
          class="flex_b"
          @click="unbindFg"
          v-if="userInfo.member.is_relation_wechat == 1"
        >
          <div>
            <qdd-icon
              class="icondelete-s"
              color="#FD3C3C"
              size=".5rem"
            ></qdd-icon>
            <span>解除微信绑定</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>
        <li class="flex_b" @click="jumpUrl('/setUp')">
          <div>
            <qdd-icon
              class="iconshezhi"
              color="#FD3C3C"
              size=".5rem"
            ></qdd-icon>
            <span>设置</span>
          </div>
          <qdd-icon class="iconyou" color="#CBCBCB" size=".4rem"></qdd-icon>
        </li>
      </ul>
    </div>
    <footerView></footerView>
    <mloading v-if="showLoading"></mloading>
    <phoneList ref="phoneList"></phoneList>
    <!--本地海报-->
    <div class="banner_poster" v-if="isShowPoster">
      <qdd-icon
        class="iconquxiao"
        color="#fff"
        size="1.2rem"
        @click="closePoster"
      ></qdd-icon>
      <h5>保存我到本地，随时随地扫码兑换</h5>
      <div class="poster_con">
        <img class="img" :src="ossImgPath + 'store_logo.png'" alt />
        <div class="poster_code">
          <i class="left"></i>
          <i class="right"></i>
          <p class="storename t_line">{{ storeInfo.store_name }}</p>
          <p class="storetip">门店信息</p>
          <p class="storetime">{{ storeInfo.phone_mob }}</p>
          <span>
            <img :src="storeInfo.new_store_qrcode" alt />
            <!--             <img :src="userInfo.store.store_qrcode" alt />-->
          </span>

          <article>
            {{ storeInfo.store_name }}积分商城二维码，快快把我放到你的相册~~
          </article>
          <button>截图保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "@/components/iconfont";
import footerView from "@/components/footerView";
import mloading from "@/components/loading.vue";
import { sendRequest } from "@/assets/public";
import phoneList from "@/components/phoneList";
import { Toast, Dialog } from "vant";
import urlconfig from "@/config.js";
import wx from "weixin-js-sdk";

export default {
  name: "personalCenter",
  components: {
    footerView,
    "qdd-icon": icon,
    mloading,
    phoneList,
  },
  data() {
    return {
      isShowPoster: false,
      userInfo: {
        member: {},
      }, //用户信息
      isLogin: localStorage.getItem("token"), //是否登录
      showLoading: true,
      jifenCon: {},
      wxStoreId: localStorage.getItem("store_id"),
      isShow: false,
      storeInfo: {}, // 店铺信息
      showpopPhone: false,
    };
  },
  created() {
    wx.hideOptionMenu();
    this.getStoreCode();

    if (!this.isLogin) {
      this.showLoading = false;
      return;
    }
    this.getInfoData();
  },

  mounted() {
    window.removeEventListener("scroll", this.handScroll);
    if (!localStorage.getItem("token")) {
      let search = window.location.href.split("?")[1]
        ? window.location.href.split("?")[1].split("code=")[1]
        : "";
      if (search) {
        this.getOpenid(
          search.indexOf("&") > -1 ? search.split("&")[0] : search
        );
      }
    }
  },
  methods: {
    goPhoneStore() {
      console.log(this.storeInfo, this.storeInfo.is_custorm_count);
      let is_custorm_count = this.storeInfo.is_custorm_count;
      if (is_custorm_count == 1) {
        //1个电话
        console.log("直接拨打");
      } else if (is_custorm_count > 1) {
        console.log("出弹框选择");
        this.$refs.phoneList.showPopFg();
      } else {
        // 0  商家没设置
        Toast(this.storeInfo.is_custorm_msg);
      }
    },
    unbindFg() {
      Dialog.confirm({
        message: "解除微信绑定后，无法实现快捷登录，确定要解除绑定吗？",
      })
        .then(() => {
          sendRequest("user/removeWechatRelation", {}).then((res) => {
            if (res.status == 200) {
              localStorage.removeItem("token");
              localStorage.removeItem("info");
              localStorage.removeItem("infor");
              Toast("解除成功");
              setTimeout(() => {
                window.location.href = `${urlconfig.goPath}`; // 注意：测试访问域名
              }, 2000);
            }
          });

          // on confirm
        })
        .catch(() => {});
    },
    async getOpenid(code) {
      console.log(code);
      let { content, status } = await sendRequest("user/login_wx", {
        code: code,
      });
      console.log(content);

      if (status == 2318) {
        localStorage.setItem(
          "pages",
          JSON.stringify({ path: "/personalCenter", query: {} })
        );
        window.location.href = window.location.href.split("?")[0] + "#/login";
      }
      if (status == 2368 || status == 2367) {
        var appid = "wxcef271c70c3c8428"; // appid
        var url = window.encodeURIComponent(
          `${urlconfig.goPath}personalCenter`
        ); // 回调链接地址，需转码为URI格式，必须去除#后的参数
        var scope = "snsapi_userinfo"; // snsapi_base静默授权，snsapi_userinfo弹出授权页面
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`;
      }
      if (status == 200) {
        localStorage.setItem("token", content.token);
        localStorage.setItem("infor", JSON.stringify(content));
        this.isLogin = content.token; //是否登录
        this.getInfoData();
      }
    },
    clear() {
      localStorage.setItem("wx", "");
    },
    // 获取用户信息
    async getInfoData() {
      let res = await sendRequest("user/info", { type: "0" });
      this.showLoading = false;
      if (res.status == 2001) {
        this.Toast("用户身份失效，请重新登录");
        localStorage.removeItem("token");
        this.getInfoData();
        return;
      }
      if (res.status != 200) {
        this.showLoading = false;
        this.Toast("用户身份失效，请重新登录");
        localStorage.removeItem("token");
        this.isLogin = false;
        return;
      }
      this.userInfo = res.content || {};
    },
    jumpUrl(url) {
      if (!this.isLogin) {
        this.goLogin();
        console.log(1);
      } else {
        console.log(2);
        window.location.href = window.location.href.split("/")[0] + `#${url}`;
      }
    },
    goLogin() {
      if (this.isWexinLogin) {
        var appid = "wxcef271c70c3c8428"; // appid
        var url = window.encodeURIComponent(
          `${urlconfig.goPath}personalCenter`
        ); // 回调链接地址，需转码为URI格式，必须去除#后的参数
        var scope = "snsapi_base"; // snsapi_base静默授权，snsapi_userinfo弹出授权页面
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`;
      } else {
        this.$router.push("/login");
      }
    },

    // 关闭海报弹框
    closePoster() {
      this.isShowPoster = false;
    },
    openPoster() {
      this.$router.push("/shareList");
      return;
      this.isShowPoster = true;
    },
    // 获取店铺二维码信息
    async getStoreCode() {
      let { content } = await sendRequest("user/storeInfo");
      console.log("--------------");
      console.log(content.store);
      this.storeInfo = content.store;
      if (content.store.mark_id >= 21) {
        localStorage.setItem("isNewMode", 1);
        this.isNewMode = 1;
      } else {
        localStorage.removeItem("isNewMode");
        this.isNewMode = 0;
      }
    },
  },
};
</script>

<style scoped>
.storeId {
  position: absolute;
  right: 0.4rem;
  top: 0.1rem;
  color: #fff;
  font-size: 0.4rem;
  text-align: right;
  z-index: 10;
}

.banner_poster {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
}

.banner_poster .iconquxiao {
  position: absolute;
  right: 1rem;
  top: 10%;
}

.banner_poster h5 {
  color: #fff;
  font-size: 0.6rem;
  text-align: center;
  padding-top: 10%;
  padding-bottom: 4%;
}

.banner_poster .poster_con {
  position: relative;
  width: 15rem;
  height: 17.74rem;
  background: url("https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/integral.png")
    no-repeat center center;
  background-size: 13rem 17.74rem;
}

.poster_con .img {
  position: absolute;
  top: -1rem;
  left: 6.5rem;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
}

.poster_code {
  position: absolute;
  width: 11rem;

  height: 15.74rem;
  background: #fff;
  border-radius: 0.2rem;
  margin: 1rem 2rem;
}

.poster_code p {
  text-align: center;
}

.poster_code .storename {
  font-size: 0.68rem;
  color: #f9641f;
  font-weight: bolder;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

.poster_code .storetip {
  color: #333;
}

.poster_code .storetime {
  color: #999;
  font-size: 0.48rem;
  padding-top: 0.4rem;
}

.poster_code article {
  font-size: 0.4rem;
  color: #999;
  text-align: center;
  padding: 0 0.3rem 0.3rem;
}

.poster_code span {
  width: 5rem;
  height: 5rem;
  background: #000;
  display: block;
  margin: 2rem 3rem;
}

.poster_code span img {
  width: 5rem;
  height: 5rem;
}

.poster_code button {
  width: 5.68rem;
  height: 1.3rem;
  background: linear-gradient(
    90deg,
    rgba(255, 195, 102, 1) 0%,
    rgba(254, 143, 97, 1) 100%
  );
  border-radius: 0.66rem;
  font-size: 0.56rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 1.3rem;
  margin: 0 auto;
  margin-top: 0.4rem;
  cursor: pointer;
  margin: 0 2.66rem;
}

.tg_shouyi {
  position: fixed;
  top: 30%;
  left: 1.26rem;
  width: 12.48rem;
  height: 8.76rem;
  background: #fff;
  border-radius: 0.36rem;
  z-index: 999;
}

.tg_shouyi h4 {
  font-size: 0.64rem;
  color: #000000;
  text-align: center;
}

.tg_shouyi p {
  padding: 0 0.6rem;
  color: #999;
  font-size: 0.56rem;
  padding-bottom: 0.4rem;
}

.tg_shouyi button {
  width: 12.48rem;
  height: 1.72rem;
  background: rgba(252, 62, 62, 1);
  border-radius: 0px 0px 0.36rem 0.36rem;
  border: none;
  outline: none;
  font-size: 0.56rem;
  color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
}

.pd2 {
  padding-bottom: 3rem;
}

a {
  color: #333;
}

.personalCenter {
  background: #f5f5f5;
  margin-bottom: 2rem;
}

.yuan {
  position: absolute;
  top: -0.2rem;
  right: 0;
  min-width: 0.44rem;
  padding: 0 0.08rem;
  height: 0.6rem;
  background: #fd3e3e;
  color: #fff;
  border-radius: 50%;
  line-height: 0.6rem;
  font-size: 0.36rem;
}

.header {
  position: relative;
}

.bg {
  width: 100%;
  height: 6rem;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.info {
  position: relative;
  z-index: 2;
  padding: 0.8rem;
  color: #fff;
  font-size: 0.68rem;
}

.info img {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
}

.info > div {
  margin: 0.2rem 0 0 0.4rem;
}

.info .login {
  margin-left: 0.4rem;
}

.badge {
  width: 1.6rem;
  height: 0.72rem;
  line-height: 0.72rem;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0.36rem;
  text-align: center;
  font-size: 0.48rem;
  margin-top: 0.3rem;
}

.go_login {
  line-height: 2rem;
  font-size: 0.68rem;
  font-weight: 500;
  margin-left: 0.34rem;
}

.order {
  margin: 0 0.4rem;
  border-radius: 0.2rem;
  background: #fff;
  padding: 0 0.4rem;
  position: relative;
  z-index: 1;
}

.order .title {
  height: 1.72rem;
  line-height: 1.72rem;
  font-size: 0.6rem;
  border-bottom: 1px solid rgba(221, 221, 221);
}

.right {
  font-size: 0.48rem;
  color: #999;
}

.order_option {
  font-size: 0.48rem;
  padding: 0.68rem 0 0.78rem;
  text-align: center;
}

.order_option li {
  position: relative;
}

.order_option img {
  width: 1rem;
  height: 1rem;
  margin: 0 auto 0.2rem;
  display: block;
}

.integral {
  margin: 0.4rem 0;
  background: #ffffff;
  height: 3.16rem;
  font-size: 0.48rem;
  font-weight: 500;
  padding: 0 0.8rem 0.6rem;
  position: relative;
}

.integral ul {
  justify-content: space-between;
  display: flex;
}

.integral .num {
  font-size: 0.7rem;
  font-weight: bold;
  margin: 0.8rem 0 0.44rem;
  text-align: left;
}

.integral li img {
  width: 1.04rem;
  height: 1.04rem;
  margin: 0.64rem 0 0.38rem;
}

.line {
  position: absolute;
  width: 0.22rem;
  height: 1.64rem;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 3.6rem;
}

.list {
  background: #ffffff;
  padding: 0 0.8rem;
}

.list li {
  height: 1.76rem;
  line-height: 1.76rem;
  font-size: 0.56rem;
  border-bottom: 1px solid #ddd;
}

.list span {
  font-size: 0.56rem;
  margin-left: 0.4rem;
  display: inline-block;
}

.list > li:last-child {
  border-bottom: none;
}

.hb_banner {
  width: 15rem;
  height: 2.8rem;
  margin: 0.4rem 0;
}

.hb_banner img {
  width: 14.22rem;
  height: 2.8rem;
  margin: 0 0.39rem;
}
.phone_tel_x {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: transparent;
}
.pr {
  position: relative;
}
</style>